(() => {
  let value;
  let savedValue;
  let pending;
  let timer;
  let updateUrl;
  let state = '';
  const fields = () => document.querySelectorAll('granite-purchase-order');
  const render = () => fields().forEach(field => {
    const input = field.querySelector('input');
    if (input && input.value !== value) input.value = value;
    field.dataset.state = state;
    field.querySelector('[role="status"]').textContent = state ? field.dataset[state] : '';
    input.setAttribute('aria-invalid', String(state === 'error'));
  });
  const save = async () => {
    clearTimeout(timer);
    if (pending) {
      await pending;
      return save();
    }
    if (value === undefined || value === savedValue) return;
    pending = (async () => {
      while (savedValue !== value) {
        const next = value;
        state = 'saving';
        render();
        const response = await fetch(updateUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'PO Number': next } })
        });
        if (!response.ok) throw new Error('PO save failed');
        const cart = await response.json();
        if (String(cart.attributes?.['PO Number'] || '') !== next) throw new Error('PO save failed');
        savedValue = next;
      }
      state = value ? 'saved' : 'cleared';
      render();
    })();
    try { await pending; }
    catch (error) { state = 'error'; render(); throw error; }
    finally { pending = null; }
  };
  class GranitePurchaseOrder extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('input');
      if (!input || this.initialized) return;
      this.initialized = true;
      updateUrl = this.dataset.updateUrl;
      if (value === undefined) value = savedValue = input.value;
      render();
      input.addEventListener('input', () => {
        value = input.value;
        state = '';
        render();
        clearTimeout(timer);
        timer = setTimeout(() => { save().catch(() => {}); }, 350);
      });
      input.addEventListener('change', () => { save().catch(() => {}); });
      input.addEventListener('keydown', event => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        save().catch(() => {});
      });
    }
  }
  customElements.define('granite-purchase-order', GranitePurchaseOrder);
  window.GranitePurchaseOrder = {
    saveForCheckout: async () => {
      try { await save(); }
      catch (error) {
        const field = Array.from(fields()).find(item => item.offsetParent !== null);
        field?.scrollIntoView({ block: 'center' });
        field?.querySelector('input')?.focus();
        throw error;
      }
    }
  };
})();
